import React from "react"
import { connect } from "react-redux"
import { Redirect, withRouter } from "react-router-dom"
import { getCurrentUser } from "redux/ducks/User"
import { createRequest } from "utils/request-helper"
import CampNewForm from "components/Form/CampNewForm"
import glamorous from "glamorous"
import style from "utils/style"

export class CampNew extends React.Component {
  state = {
    formError: undefined,
  }

  createCamp(values, bag) {
    const data = {
      data: {
        type: "camps",
        attributes: {
          name: values.name,
          email: values.email,
          camp_address: values.camp_address,
          camp_address_2: values.camp_address_2,
          camp_city: values.camp_city,
          camp_state: values.camp_state,
          camp_zip: values.camp_zip,
          camp_country: values.camp_country,
          camp_phone: values.camp_phone,
          camp_fax: values.camp_fax,
          website: values.website,
          camp_type_day: values.camp_type_day,
          camp_type_sleep_away: values.camp_type_sleep_away,
          camp_enrollment: values.camp_enrollment,
          camp_age_range: values.camp_age_range,
          camp_gender: values.camp_gender,
          camp_accreditation: values.camp_accreditation,
          description_brief_campers: values.description_brief_campers,
          description_full_campers: values.description_full_campers,
          facebook: values.facebook,
          twitter: values.twitter,
          skype: values.skype,
          instagram: values.instagram,
          youtube: values.youtube,
          campers_session_start_date: this.formatDate(
            values.session_start_date_year,
            values.session_start_date_month,
            values.session_start_date_day
          ),
          campers_session_end_date: this.formatDate(
            values.session_end_date_year,
            values.session_end_date_month,
            values.session_end_date_day
          ),
          dates_and_rates: values.dates_and_rates,
        },
        relationships: {
          camp_specialties: this.buildRelationships(
            "camp_specialties",
            values.camp_specialty_ids
          ),
          camp_expertises: this.buildRelationships(
            "camp_expertises",
            values.camp_expertise_ids
          ),
        },
      },
    }

    createRequest(
      {
        method: "POST",
        route: "camps",
        data,
      },
      response => {
        createRequest(
          {
            method: "PATCH",
            route: `users/${this.props.currentUser.id}`,
            data: {
              data: {
                type: "users",
                attributes: {
                  camp_id: response.data.data.id,
                },
              },
            },
          },
          response => {
            this.props.getCurrentUser()
            this.props.history.push("/billing")
          },
          userError =>
            this.setState({
              formError: `Error assigned user: ${userError.response
                .status} ${userError.response.statusText}`,
            })
        )
      },
      error => {
        bag.setSubmitting(false)
        this.setState({
          formError: `Error: ${error.response.status} ${error.response
            .statusText}`,
        })
      }
    )
  }

  formatDate(year, month, day) {
    if (month < 10) month = `0${month}`
    if (day < 10) day = `0${day}`
    return `${year}-${month}-${day}`
  }

  buildRelationships(type, ids) {
    let data = []
    ids.forEach(id => data.push({ type, id }))
    return { data }
  }

  render() {
    return (
      <Container>
        {this.props.currentUser ? (
          <CampNewForm
            handleSubmit={this.createCamp.bind(this)}
            formError={this.state.formError}
          />
        ) : (
          <Redirect to="/staff/new" />
        )}
      </Container>
    )
  }
}

export const mapStateToProps = state => ({
  currentUser: state.user.currentUser,
})

export const mapDispatchToProps = dispatch => ({
  getCurrentUser: () => dispatch(getCurrentUser()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CampNew))

const Container = glamorous.div({
  display: "flex",
  flexDirection: "column",
  background: style.colors.lightMintGreen,
  justifyContent: "center",
  alignItems: "center",
  padding: "3rem",
  [style.size.mobile]: {
    padding: 0,
  },
})



// WEBPACK FOOTER //
// ./src/scenes/Camp/CampNew/index.js